// src/pages/PaymentSuccess.jsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService'; // your api service
import { CheckCircleIcon } from '@heroicons/react/24/solid'; // optional icon (or use emoji)

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [planName, setPlanName] = useState('your plan');

  useEffect(() => {
    if (!sessionId) {
      setError('Invalid session');
      setLoading(false);
      return;
    }

    // Optional: fetch session details from your backend to show personalized message
    const fetchSessionDetails = async () => {
      try {
        const res = await apiService.get(`/stripe/session/${sessionId}`);
        console.log("res************",res)
        // You can return plan name, amount, interval etc.
        setPlanName(res?.planName || 'Subscription');
      } catch (err) {
        console.error(err);
        // Don't break the UI — fallback message is fine
      } finally {
        setLoading(false);
      }
    };

    fetchSessionDetails();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {loading ? (
          <div className="animate-pulse">Verifying your payment...</div>
        ) : error ? (
          <div className="text-red-600">
            <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
            <p>{error}</p>
            <button
              onClick={() => navigate('/pricing')}
              className="mt-6 bg-indigo-600 text-white px-6 py-3 rounded-lg"
            >
              Back to Pricing
            </button>
          </div>
        ) : (
          <>
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto mb-6" />
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              Thank You!
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Your payment was successful. <br />
              {planName} access has been activated.
            </p>

            <div className="space-y-4">
              <button
                onClick={() => navigate('/user')}
                className="w-full bg-indigo-600 text-white py-3 px-6 rounded-lg hover:bg-indigo-700 font-medium"
              >
                Go to Dashboard
              </button>

              <button
                onClick={() => navigate('/subscriptions')}
                className="w-full bg-gray-200 text-gray-800 py-3 px-6 rounded-lg hover:bg-gray-300 font-medium"
              >
                View All Plans
              </button>
            </div>

            {/* Updated contact message */}
          <p className="mt-8 text-sm text-gray-600">
            If you have any query or need B2B additional services, please contact us at{' '}
            <a 
              href="mailto:info@yourdomain.com" 
              className="text-indigo-600 hover:underline font-medium"
            >
              info@chickfarm.site
            </a>
          </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;